import FilterListIcon from "@mui/icons-material/FilterList";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";

import ColumnSelector from "../../../design/column-selector";
import Searchbar from "../../../design/search-bar";
import { JobsMatrixColumnConfig } from "../controller/use-jobs-matrix-columns";
import { JobStatus } from "../store/types";
import JobsMatrixLegend from "./jobs-matrix-legend";

interface JobsMatrixHeaderProps {
    searchText: string;
    onSearchChange: (value: string) => void;
    jobStatuses: JobStatus[];
    pickerColumns: JobsMatrixColumnConfig[];
    handleSelectColumns: (checked: boolean, field: string) => void;
    disabledColumns: string[];
    isFilterOpen: boolean;
    setIsFilterOpen: (open: boolean) => void;
    filterStatus: string;
}

const JobsMatrixHeader: React.FC<JobsMatrixHeaderProps> = ({
    searchText,
    onSearchChange,
    jobStatuses,
    pickerColumns,
    handleSelectColumns,
    disabledColumns,
    isFilterOpen,
    setIsFilterOpen,
    filterStatus,
}) => {
    return (
      <Box display="flex" flexDirection="column" px={3} py={1.2} width={"100%"}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="row"
          sx={{
            flex: 1,
          }}
        >
          <ColumnSelector
            columns={pickerColumns}
            handleSelectColumns={handleSelectColumns}
            disabledColumns={disabledColumns}
          />
          <Searchbar
            placeholder=""
            setSearch={(value) => onSearchChange(value)}
            value={searchText}
            debounce
          />
          <Box
            display="flex"
            alignItems="center"
            sx={{
              marginLeft: "24px",
            }}
          >
            <JobsMatrixLegend jobStatuses={jobStatuses} />
          </Box>
        </Box>
      </Box>
    );
};

export default JobsMatrixHeader;
